export const environment = {
  production: false,
  apiUrl: 'https://rainbow-surrogacy-api-dev.crio-server.com/api',
  locale: 'en',
  fallbackLocale: 'en',
};
